import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41b42901"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg dark", { hide: !$setup.darkMode }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["bg light", { hide: $setup.darkMode }])
    }, null, 2)
  ]))
}